export default () => ({
  loading: false,
  error: false,
  currentCourse: null,
  courseCategories: [],

  // Translations - will be injected from server
  translations: {
    modal_title: 'Porovnání kurzů',
    loading: 'Načítání kurzů...',
    error_message: 'Nepodařilo se načíst kurzy. Zkuste to prosím později.',
    no_courses: 'Žádné kurzy k porovnání.',
    no_courses_category: 'Žádné kurzy v této kategorii.',
    current_badge: 'Aktuální',
    course_name: 'Název kurzu',
    duration: 'Délka',
    price: 'Cena',
    language: 'Jazyk',
    level: 'Úroveň',
    requirements: 'Požadavky',
    certification: 'Certifikace',
    days: 'dny',
    on_request: 'Na vyžádání',
    no_certification: 'Bez certifikace',
    no_requirements: 'Žádné požadavky',
    requirements_count: 'požadavků',
    level_basic: 'Základní',
    level_intermediate: 'Střední',
    level_advanced: 'Pokročilý',
    level_expert: 'Expertní',
  },

  async init() {
    // Load translations from API
    await this.loadTranslations();

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-modal="modal-comparator"]');
      if (trigger) {
        setTimeout(() => {
          this.handleModalOpen(trigger);
        }, 100);
      }
    });
  },

  async loadTranslations() {
    // Skip if translations are already loaded (check for a key that should be present)
    if (this.translations.modal_title && this.translations.modal_title !== 'Porovnání kurzů') {
      return;
    }

    try {
      const locale = this.getCurrentLocale();
      const response = await fetch(`/api/v1/translations/comparator?locale=${locale}`);
      if (response.ok) {
        const apiTranslations = await response.json();
        this.translations = { ...this.translations, ...apiTranslations };
      }
    } catch (error) {
      console.error('Failed to load translations:', error);
    }
  },

  getCurrentLocale() {
    // Get locale from the URL path or default to 'cs'
    const path = window.location.pathname;
    const match = path.match(/^\/([a-z]{2})\//);
    return match ? match[1] : 'cs';
  },

  /**
   * Set translations for the component
   */
  setTranslations(translations) {
    this.translations = { ...this.translations, ...translations };
  },

  async handleModalOpen(trigger) {
    console.log('Course comparator modal opened', trigger);
    const courseId = trigger.dataset.courseId;
    const methodicSlug = trigger.dataset.courseMethodics;

    console.log('Course ID:', courseId, 'Methodic slug:', methodicSlug);

    if (!courseId || !methodicSlug) {
      console.error('Missing course ID or methodic slug');
      return;
    }

    this.showLoading();

    try {
      // Ensure translations are loaded before processing data
      await this.loadTranslations();

      this.currentCourse = await this.getCurrentCourseData(courseId);
      this.courseCategories = await this.getCoursesByMethodic(methodicSlug, courseId);
      this.showContent();
    } catch (error) {
      console.error('Error loading courses:', error);
      this.showError();
    }
  },

  async getCurrentCourseData(courseId) {
    try {
      const response = await fetch(`/api/v1/courses/${encodeURIComponent(courseId)}`);

      if (!response.ok) {
        console.error('Failed to fetch current course data:', response.status, response.statusText);
        throw new Error(`Failed to fetch current course data: ${response.status}`);
      }

      const courseData = await response.json();

      return {
        ...courseData,
        isCurrent: true,
      };
    } catch (error) {
      console.error('Error fetching current course data:', error);
      throw error;
    }
  },

  async getCoursesByMethodic(methodicSlug, excludeId) {
    try {
      const locale = this.getCurrentLocale();
      const url = `/api/v1/courses/methodic?methodic=${encodeURIComponent(methodicSlug)}&exclude_id=${encodeURIComponent(
        excludeId
      )}&limit=10&locale=${locale}`;
      console.log('Fetching courses from:', url);

      const response = await fetch(url);

      if (!response.ok) {
        console.error('Failed to fetch courses:', response.status, response.statusText);
        throw new Error(`Failed to fetch courses: ${response.status}`);
      }

      const categories = await response.json();

      return categories.map((category) => ({
        ...category,
        courses: category.courses.map((course) => ({ ...course, isCurrent: false }))
      }));
    } catch (error) {
      console.error('Error fetching courses by methodic:', error);
      throw error;
    }
  },

  async getMinPriceForCourse(courseId) {
    try {
      const response = await fetch(`/api/v1/events/course/${encodeURIComponent(courseId)}`);

      if (response.ok) {
        const events = await response.json();
        const minPrice = Math.min(...events.map((event) => event.price || 0));
        return Number.isFinite(minPrice) && minPrice > 0 ? minPrice : 0;
      }
    } catch (error) {
      console.error('Error fetching price:', error);
    }

    return 0;
  },


  showLoading() {
    this.loading = true;
    this.error = false;

    document.querySelector('.comparator-loading').style.display = 'block';
    document.querySelector('.comparator-content').style.display = 'none';
    document.querySelector('.comparator-error').style.display = 'none';
  },

  showContent() {
    this.loading = false;
    this.error = false;


    const comparatorContent = document.querySelector('.comparator-content');
    if (comparatorContent) {
      comparatorContent.innerHTML = this.createCategoryTables();
    }

    document.querySelector('.comparator-loading').style.display = 'none';
    document.querySelector('.comparator-content').style.display = 'block';
    document.querySelector('.comparator-error').style.display = 'none';
  },

  showError() {
    this.loading = false;
    this.error = true;

    document.querySelector('.comparator-loading').style.display = 'none';
    document.querySelector('.comparator-content').style.display = 'none';
    document.querySelector('.comparator-error').style.display = 'block';
  },

  /**
   * Creates HTML for multiple category tables
   */
  createCategoryTables() {
    if (!this.courseCategories || this.courseCategories.length === 0) {
      return `<div class="comparator-empty">${this.translations.no_courses}</div>`;
    }

    let html = '';

    this.courseCategories.forEach((category, categoryIndex) => {
      const allCourses = [this.currentCourse, ...category.courses].filter(Boolean);

      // Skip categories with no courses to compare
      if (allCourses.length <= 1) {
        return;
      }

      const categoryLabel = this.getCategoryLabel(category.label);
      const categoryDescription = this.getCategoryDescription(category.description);

      html += `
        <div class="comparator-category" data-category-index="${categoryIndex}">
          <div class="comparator-category__header">
            <h3 class="comparator-category__title">${this.escapeHtml(categoryLabel)}</h3>
            ${categoryDescription ? `<p class="comparator-category__description">${this.escapeHtml(categoryDescription)}</p>` : ''}
          </div>
          <div class="comparator-category__table">
            ${this.createFlippedTable(allCourses)}
          </div>
        </div>
      `;
    });

    return html || `<div class="comparator-empty">${this.translations.no_courses}</div>`;
  },


  createFlippedTable(courses) {
    if (courses.length === 0) {
      return `<div class="comparator-empty">${this.translations.no_courses_category}</div>`;
    }

    return `
      <div class="comparator-table-wrapper">
        <table class="comparator-table comparator-table--flipped">
          <tbody id="comparator-tbody-flipped-${courses[0]?.id || 'default'}">
            ${this.createFlippedTableBody(courses)}
          </tbody>
        </table>
      </div>
    `;
  },

  createFlippedTableBody(courses) {
    if (courses.length === 0) {
      return `<tr><td colspan="7">${this.translations.no_courses}</td></tr>`;
    }

    const properties = [
      {
        key: 'title',
        label: this.translations.course_name,
        renderer: (course) =>
          `<a href="${this.escapeHtml(course.url || '#')}">${this.escapeHtml(course.title || 'N/A')}</a> ${course.isCurrent ? `<span class="current-badge">${this.translations.current_badge}</span>` : ''}`,
      },
      { key: 'duration', label: this.translations.duration, renderer: (course) => course.duration ? `${course.duration} ${this.translations.days}` : 'N/A' },
      { key: 'price', label: this.translations.price, renderer: (course) => this.getPriceText(course.price) },
      { key: 'language', label: this.translations.language, renderer: (course) => this.escapeHtml(course.language || 'N/A') },
      { key: 'level', label: this.translations.level, renderer: (course) => this.getLevelText(course.level) },
      { key: 'requirements', label: this.translations.requirements, renderer: (course) => this.getRequirementsText(course.requirements) },
      { key: 'certification', label: this.translations.certification, renderer: (course) => this.getCertificationText(course.certification) },
    ];

    let html = '';

    properties.forEach((prop) => {
      html += '<tr>';
      html += `<th>${prop.label}</th>`;

      courses.forEach((course) => {
        const cellContent = prop.renderer(course);
        const currentClass = course.isCurrent ? 'current-course' : '';
        html += `<td class="${currentClass} course-${prop.key}">${cellContent}</td>`;
      });

      html += '</tr>';
    });

    return html;
  },

  getPriceText(price) {
    return price > 0 ? this.formatPrice(price) : this.translations.on_request;
  },

  getCertificationText(certification) {
    return certification?.has_certification ? certification.title : this.translations.no_certification;
  },

  getLevelText(level) {
    if (!level) return 'N/A';

    const levelMap = {
      1: this.translations.level_basic,
      2: this.translations.level_intermediate,
      3: this.translations.level_advanced,
      4: this.translations.level_expert,
    };

    return levelMap[level] || level;
  },

  getRequirementsText(requirements) {
    if (!requirements || requirements.length === 0) {
      return this.translations.no_requirements;
    }
    if (requirements.length === 1) {
      return requirements[0];
    }
    return `${requirements.length} ${this.translations.requirements_count}`;
  },


  formatPrice(price) {
    return new Intl.NumberFormat('cs-CZ', {
      style: 'currency',
      currency: 'CZK',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  },

  /**
   * Get category label with translation support
   */
  getCategoryLabel(labelData) {
    if (!labelData) {
      return this.translations.default_category || 'Kurzy';
    }

    if (typeof labelData === 'string') {
      return labelData;
    }

    if (labelData.text) {
      return labelData.text;
    }

    if (labelData.translation_key) {
      return this.translations[labelData.translation_key] || labelData.fallback || 'Kurzy';
    }

    return labelData.fallback || 'Kurzy';
  },

  /**
   * Get category description with translation support
   */
  getCategoryDescription(descriptionData) {
    if (!descriptionData) {
      return null;
    }

    if (typeof descriptionData === 'string') {
      return descriptionData;
    }

    if (descriptionData.texts && Array.isArray(descriptionData.texts) && descriptionData.texts.length > 0) {
      const description = descriptionData.texts.join(' ').trim();
      return description || null;
    }

    return descriptionData.fallback || null;
  },

  /**
   * Escape HTML to prevent XSS attacks
   */
  escapeHtml(text) {
    if (typeof text !== 'string') {
      return text;
    }

    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };

    return text.replace(/[&<>"']/g, (m) => map[m]);
  },
});
